export default __webpack_public_path__ + "static/media/image5.ff03f8c3.jpg";